<div class="row mb-3">
  <div class="col-12">
    <mbs-button-group class="row"
                      [toggle]="true"
                      [customClasses]="'col-12'">
      <mbs-button class="w-100 d-flex justify-content-center align-items-center"
                  [customClasses]="'w-100 d-flex justify-content-center align-items-center'"
                  [active]="isUnifiedSetup"
                  (click)="setUnifiedMode(true)">
        {{ 'mbs-ui:rmm-custom-alerting.wizard.secondStep.unified' | i18next }}
      </mbs-button>
      <mbs-button class="w-100 d-flex justify-content-center align-items-center"
                  [customClasses]="'w-100 d-flex justify-content-center align-items-center'"
                  [active]="!isUnifiedSetup"
                  (click)="setUnifiedMode(false)">
        {{ 'mbs-ui:rmm-custom-alerting.wizard.secondStep.forEach' | i18next }}
      </mbs-button>
    </mbs-button-group>

  </div>
</div>

<ng-container *ngIf="!loading">

  <mbs-alert *ngIf="noEnabledAlerts"
             type="warning"
             [icon]="true">
    <div class="fw-bold">
      {{ 'mbs-ui:rmm-custom-alerting.alertNotEnabledErrorTitle' | i18next }}
    </div>
    <div>
      {{ 'mbs-ui:rmm-custom-alerting.alertNotEnabledErrorDesc' | i18next }}
    </div>
  </mbs-alert>

  <ng-container *ngIf="!noEnabledAlerts">
    <ng-template *ngTemplateOutlet="isUnifiedSetup ? unifiedSetup : separateSetup"></ng-template>
  </ng-container>

  <ng-template #unifiedSetup>
    <mbs-common-profile-notification-settings [enabled]="isUnifiedSetup"
                                              [postActions]="postActions"
                                              [includeConnectWise]="includeConnectWise">
    </mbs-common-profile-notification-settings>
  </ng-template>

  <ng-template #separateSetup>
    <mbs-alert-profile-notifications [enabled]="!isUnifiedSetup"
                                     [postActions]="postActions"
                                     [unifiedPostActions]="unifiedPostActions"
                                     [includeConnectWise]="includeConnectWise">
    </mbs-alert-profile-notifications>
  </ng-template>
</ng-container>
